import { Divider, Skeleton, Tab, Tabs } from '@mui/material';
import { Link, Outlet, useLocation } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/organisms/page/page';
import { Route } from 'src/routes/_layout/tenant/employees/groups/$groupToken/_layout';
import { useEmployeesGroupsByTokens } from '../api/hooks/use-employees-groups-by-tokens';

export const EmployeesGroupDetailsContainer = () => {
  const { groupToken } = Route.useParams();
  const location = useLocation();

  const { t } = useTranslation('employeesGroups');

  const { results } = useEmployeesGroupsByTokens([groupToken]);

  const tabs = [
    {
      href: `/tenant/employees/groups/${groupToken}/employees`,
      label: t('employees.title'),
    },
    {
      href: `/tenant/employees/groups/${groupToken}/booking-rules`,
      label: t('bookingRules.title'),
    },
    {
      href: `/tenant/employees/groups/${groupToken}/space-groups`,
      label: t('spaceGroups.title'),
    },
    {
      href: `/tenant/employees/groups/${groupToken}/bookings`,
      label: t('bookings.title'),
    },
  ];

  return (
    <>
      <Page>
        <Page.BackButton href="/tenant/employees/groups" />

        {results?.hits ? (
          <Page.Header title={results.hits[0].name} />
        ) : (
          <Skeleton />
        )}

        <Tabs
          allowScrollButtonsMobile
          sx={{ mt: 4 }}
          value={tabs.findIndex(tab => tab.href.includes(location.pathname))}
          variant="scrollable">
          {tabs.map(option => (
            <Tab
              component={Link}
              key={option.href}
              label={option.label}
              to={option.href}
            />
          ))}
        </Tabs>
        <Divider />
        <Outlet />
      </Page>
    </>
  );
};
